import { Create, Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Typography, Box } from '@mui/material';
import { ONBOARDING_STAGES, CONTRACT_TYPES } from './constants';

export const EmployeeCreate = () => (
  <Create>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Personal Information</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="firstName" fullWidth />
        <TextInput source="lastName" fullWidth />
        <TextInput source="idNumber" label="ID Number" fullWidth helperText="13-digit RSA ID" />
        <TextInput source="dateOfBirth" type="date" fullWidth />
        <SelectInput source="gender" choices={[{ id: 'Male', name: 'Male' }, { id: 'Female', name: 'Female' }]} fullWidth />
        <SelectInput source="race" choices={['African', 'Coloured', 'Indian', 'White'].map(r => ({ id: r, name: r }))} fullWidth />
        <TextInput source="email" type="email" fullWidth />
        <TextInput source="phone" fullWidth />
      </Box>
      <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Employment Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="position" label="Position / Job Title" fullWidth />
        <SelectInput source="department" choices={['Finance', 'IT', 'HR', 'Operations', 'Sales', 'Marketing', 'Legal', 'Compliance'].map(d => ({ id: d, name: d }))} fullWidth />
        <SelectInput source="contractType" choices={CONTRACT_TYPES.map(c => ({ id: c, name: c }))} fullWidth />
        <TextInput source="startDate" type="date" fullWidth />
        <TextInput source="probationEndDate" type="date" label="Probation End Date" fullWidth />
        <SelectInput source="occupationalLevel" choices={['TopManagement', 'SeniorManagement', 'ProfessionallyQualified', 'SkilledTechnical', 'SemiSkilled', 'Unskilled'].map(o => ({ id: o, name: o }))} fullWidth />
        <SelectInput source="status" choices={['Pending', 'Active'].map(s => ({ id: s, name: s }))} fullWidth defaultValue="Pending" />
        <SelectInput source="currentStage" choices={ONBOARDING_STAGES.map(s => ({ id: s, name: s }))} fullWidth defaultValue="Documentation" />
      </Box>
    </SimpleForm>
  </Create>
);

export const EmployeeEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Personal Information</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="firstName" fullWidth />
        <TextInput source="lastName" fullWidth />
        <TextInput source="idNumber" label="ID Number" fullWidth />
        <TextInput source="dateOfBirth" type="date" fullWidth />
        <SelectInput source="gender" choices={[{ id: 'Male', name: 'Male' }, { id: 'Female', name: 'Female' }]} fullWidth />
        <SelectInput source="race" choices={['African', 'Coloured', 'Indian', 'White'].map(r => ({ id: r, name: r }))} fullWidth />
        <TextInput source="email" type="email" fullWidth />
        <TextInput source="phone" fullWidth />
      </Box>
      <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>Employment Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="position" label="Position / Job Title" fullWidth />
        <SelectInput source="department" choices={['Finance', 'IT', 'HR', 'Operations', 'Sales', 'Marketing', 'Legal', 'Compliance'].map(d => ({ id: d, name: d }))} fullWidth />
        <SelectInput source="contractType" choices={CONTRACT_TYPES.map(c => ({ id: c, name: c }))} fullWidth />
        <TextInput source="startDate" type="date" fullWidth />
        <TextInput source="probationEndDate" type="date" label="Probation End Date" fullWidth />
        <SelectInput source="occupationalLevel" choices={['TopManagement', 'SeniorManagement', 'ProfessionallyQualified', 'SkilledTechnical', 'SemiSkilled', 'Unskilled'].map(o => ({ id: o, name: o }))} fullWidth />
        <SelectInput source="status" choices={['Pending', 'Active', 'Suspended', 'OnProbation', 'Terminated'].map(s => ({ id: s, name: s }))} fullWidth />
        <SelectInput source="currentStage" choices={ONBOARDING_STAGES.map(s => ({ id: s, name: s }))} fullWidth />
      </Box>
    </SimpleForm>
  </Edit>
);
